import { useState } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/components/ui/sonner";
import { stagingCosts } from "@/data/mockData";

export const CreditCostForm = () => {
  const [costs, setCosts] = useState(stagingCosts);

  const handleCostChange = (id: string, newCost: number) => {
    setCosts(costs.map(cost => 
      cost.id === id ? { ...cost, creditCost: newCost } : cost
    ));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Náklady na kredity byly úspěšně aktualizovány!");
    // This is where we would update the database with the new costs
    // after Supabase integration
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Nastavení nákladů na kredity</CardTitle>
        <CardDescription>
          Nastavte, kolik kreditů stojí každá služba
        </CardDescription>
      </CardHeader>
      <form onSubmit={handleSubmit}>
        <CardContent className="space-y-4">
          {costs.map(cost => (
            <div key={cost.id} className="grid grid-cols-2 gap-4 items-center">
              <Label htmlFor={`cost-${cost.id}`}>{cost.service}</Label>
              <Input
                id={`cost-${cost.id}`}
                type="number"
                min="1"
                value={cost.creditCost}
                onChange={(e) => handleCostChange(cost.id, parseInt(e.target.value) || 1)}
              />
            </div>
          ))}
        </CardContent>
        <CardFooter>
          <Button type="submit" className="ml-auto">Uložit změny</Button>
        </CardFooter>
      </form>
    </Card>
  );
};
